import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs, Tab } from 'foundations-components/transitional/components/Tabs';
import { SchedulingSteps } from './constants';
import useContentCrmObject from '../../hooks/useContentCrmObject';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { SuccessIcon } from 'foundations-assets/icons/components/SuccessIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SchedulingTabs = ({
  tabType,
  handleTabChange,
  canScheduleUnpublish,
  currentStep,
  scheduledPublishDateTime
}) => {
  const {
    isContentCrmObjectScheduled,
    isContentCrmObjectPublished
  } = useContentCrmObject();
  const isUnpublishTabEnabled = isContentCrmObjectScheduled || isContentCrmObjectPublished || scheduledPublishDateTime;
  if (!canScheduleUnpublish) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Tabs, {
    selected: tabType,
    fill: true,
    use: "enclosed",
    onSelectedChange: e => {
      handleTabChange(e.target.value);
    },
    children: [/*#__PURE__*/_jsx(Tab, {
      tabId: "schedulePublish",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [currentStep.schedulePublish === SchedulingSteps.SCHEDULING && /*#__PURE__*/_jsx(IconHolder, {
          icon: SuccessIcon
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.tabs.schedulePublish"
        })]
      })
    }), /*#__PURE__*/_jsx(Tab, {
      tabId: "scheduleUnpublish",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [currentStep.scheduleUnpublish === SchedulingSteps.SCHEDULING && /*#__PURE__*/_jsx(IconHolder, {
          icon: SuccessIcon
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "baseSchedulingOptionsModal.tabs.scheduleUnpublish"
        })]
      }),
      disabled: !isUnpublishTabEnabled
    })]
  });
};
export default SchedulingTabs;